export const songFields = [
    {
        label: "Artist",
        slug: "artist",
        placeholder: "Avicii",
        type: "text"
    },
    {
        label: "Title",
        slug: "title",
        placeholder: "The Nights",
        type: "text"
    },
    {
        label: "Year",
        slug: "year",
        placeholder: "2012",
        type: "number"
    },
    {
        label: "Album",
        slug: "album",
        placeholder: "The days/nights",
        type: "text"
    },
    {
        label: "Songwriter",
        slug: "songwriter",
        placeholder: "Nick Furlong",
        type: "text"
    },
    {
        label: "Runtime (HH:MM:SS)",
        slug: "runtime",
        placeholder: "00:05:42",
        type: "text"
    }
];
